import { Header } from '@yanolja-org/core-ui';
import { IcFavoriteFillH18, IcFavoriteH18 } from '@yanolja-org/nol-icons-kit';

import type { HeaderActionProps, VisibleOn } from '@yanolja-org/core-ui';

/** preset 전용 — `'all'` 명시 시 양쪽 모두 노출. @see MyAction 의 PresetVisibleOn 주석 */
type PresetVisibleOn = VisibleOn | 'all';

export interface WishActionProps extends Omit<HeaderActionProps, 'icon' | 'activeIcon' | 'action' | 'visibleOn'> {
  action?: string;
  /** 표시 디바이스. `'all'` = 양쪽 모두. @default 'desktop' */
  visibleOn?: PresetVisibleOn;
}

export function WishAction({
  action = 'wishlist',
  label = '찜',
  variant = 'label',
  visibleOn = 'desktop',
  href = '/member/wishlist',
  ...rest
}: WishActionProps) {
  return (
    <Header.Action
      {...rest}
      action={action}
      activeIcon={<IcFavoriteFillH18 />}
      href={href}
      icon={<IcFavoriteH18 />}
      label={label}
      variant={variant}
      visibleOn={visibleOn === 'all' ? undefined : visibleOn}
    />
  );
}
